module.exports = __webpack_public_path__ + "assets/images/cosmote_1.808a572d2ea707f188ab03997b2d5d55.png";